<template>
  <div>
    <v-layout row wrap fill-height>
      <v-flex xs12 fill-height>
        <v-card
          flat
          class="trailer-player"
          width="100%"
          height="600px"
        ></v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import Artplayer from "artplayer";
export default {
  name: "PreviewTrailer",
  props: {
    url: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      player: null,
      isEnded: false,
    };
  },
  mounted() {
    this.initialisePlayer();
  },

  beforeDestroy() {
    if (this.player) {
      this.player.destroy();
    }
  },

  methods: {
    async initialisePlayer() {
      /**
       * 1. Load all default configurations of player
       * 2. Configure all event listeners with its listners
       */
      await this.loadPlayer();
      this.configureAllEventListeners(this.player);
    },

    loadPlayer() {
      let _this = this;
      return (this.player = new Artplayer({
        container: ".trailer-player",
        autoMini: true,
        pip: true,
        url: this.url,
        fullscreen: true,
        whitelist: ["*"],
        fullscreenToggle: true,
        autoplay: true,
        pause: false,
        customType: {
          m3u8: _this.initialiseHlsPlayer
        },
      }));
    },

    /**
     * This function is responsible to handeling HLS initialization
     */
     initialiseHlsPlayer(video, url, art) {
            if (Hls.isSupported()) {
                const hls = new Hls();
                hls.loadSource(url);
                hls.attachMedia(video);

                // optional
                art.hls = hls;
                art.once('url', () => hls.destroy());
                art.once('destroy', () => hls.destroy());
            } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
                video.src = url;
            } else {
                art.notice.show = 'Unsupported playback format: m3u8';
            }
        },

    /**
     * Configure all event listners with its handeler
     */
    configureAllEventListeners(playerInstance) {
      let _this = this;
      playerInstance.on("video:ended", () => {
        _this.onVideoEnd(playerInstance);
      });
    },

    //Handel video ready state
    onVideoEnd(playerInstance) {
      //need to destroy otherwise event listener causes problem
      playerInstance.destroy();
    },
  },
};
</script>
<style scoped></style>
